var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('div',[_c('vue-load-image',[_c('img',{staticClass:"img-responsive",attrs:{"slot":"image","src":`${_vm.IMAGEURL}${_vm.image}`,"alt":""},slot:"image"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }